import { useTranslation } from 'react-i18next';

import Loading from '../Loading/loading';

const FullPageLoading = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full h-full">
      <Loading title={t('Global.WaitingMessage')} />
    </div>
  );
};
export default FullPageLoading;
